
import React from 'react';
import { Autocomplete, TextField, Grid } from '@mui/material';
import axiosInstance from '../lib/axios'
import { useEffect, useState } from 'react';

const PropertyFilter = ({ SelectedProperty, setSelectedProperty, searchTerms, setSearchTerms, userId, label = "Filter by Property", width = 250 }) => {
  const [propertyOptions, setPropertyOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchPropertyOptions = async () => {
      try {
        setLoading(true);
        const response = await axiosInstance.post(`PropertyMst/GetPropertyMstUserwisedrp`, {
          UserId: userId,
          Flag: ""
        });
        
        if (response.data.Status === 0 && response.data.Data) {
          const options = response.data.Data;
          setPropertyOptions(options);
          if (options.length > 0 && !SelectedProperty) {
            const firstOption = options[0];
            setSelectedProperty(firstOption);
            setSearchTerms(prev => ({ ...prev, PropId: firstOption.Id }));
          }
        }
      } catch (error) {
        console.error("Error fetching properties", error);
      } finally {
        setLoading(false);
      }
    };

    if (userId) {
      fetchPropertyOptions();
    }
  }, [userId, SelectedProperty, setSelectedProperty, setSearchTerms]);

  const handlePropertyChange = (event, newValue) => {
    setSelectedProperty(newValue);
    
    if (newValue) {
      setSearchTerms(prev => ({ ...prev, PropId: newValue.Id }));
    } else {
      const { PropId, ...rest } = searchTerms;
      setSearchTerms(rest);
    }
  };

  return (
    <Grid item xs={12} md={3}>
      <Autocomplete
        options={propertyOptions}
        getOptionLabel={(option) => option?.Name || ''}
        isOptionEqualToValue={(option, value) => 
          option?.Id === value?.Id || 
          (option === null && value === null)
        }
        value={SelectedProperty || null}
        onChange={handlePropertyChange}
        loading={loading}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            variant="outlined"
            size="small"
            sx={{ minWidth: width }}
          />
        )}
      />
    </Grid>
  );
};

export default PropertyFilter;